// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-now';

export const Component = () => (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M18.63 2.963h4.933c.24 0 .48.096.67.288a.946.946 0 0 1 .288.67v19.636c0 .24-.096.479-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V3.921c0-.239.096-.479.288-.67a.946.946 0 0 1 .67-.288H5.89V1.48c0-.335.143-.479.479-.479s.478.144.478.479v1.484h10.824V1.48c0-.335.144-.479.479-.479.335 0 .479.144.479.479zm4.933 20.74V9H.956v14.703zm0-19.781v3.927H.956V3.922zM12 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'
  />
);

export const viewBox = '0 0 25 25';
